// Admin Page — verification queue with audit log
import { useState } from "react";
import { PageHeader } from "@/components/shared";
import { VerificationQueue } from "@/components/admin/VerificationQueue";
import { AuditLogViewer } from "@/components/admin/AuditLogViewer";
import { AbuseFlagList } from "@/components/admin/AbuseFlagList";
import { Shield, ClipboardList, AlertTriangle } from "lucide-react";

type AdminTab = "queue" | "audit" | "abuse";

export function AdminPage() {
  const [activeTab, setActiveTab] = useState<AdminTab>("queue");
  const [selectedAgentId, setSelectedAgentId] = useState<string | null>(null);

  return (
    <div>
      <PageHeader
        title="PPRA Verification Queue"
        description="Review and approve agent PPRA credentials."
      />

      {/* Tab navigation */}
      <div className="flex gap-4 border-b border-white/10 mb-6">
        <button
          onClick={() => setActiveTab("queue")}
          className={`flex items-center gap-2 pb-3 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "queue"
              ? "border-gold text-sun"
              : "border-transparent text-white/50 hover:text-white/70"
          }`}
        >
          <Shield className="h-4 w-4" />
          Verification Queue
        </button>
        <button
          onClick={() => setActiveTab("audit")}
          className={`flex items-center gap-2 pb-3 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "audit"
              ? "border-gold text-sun"
              : "border-transparent text-white/50 hover:text-white/70"
          }`}
        >
          <ClipboardList className="h-4 w-4" />
          Audit Log
        </button>
        <button
          onClick={() => setActiveTab("abuse")}
          className={`flex items-center gap-2 pb-3 text-sm font-medium border-b-2 transition-colors ${
            activeTab === "abuse"
              ? "border-gold text-sun"
              : "border-transparent text-white/50 hover:text-white/70"
          }`}
        >
          <AlertTriangle className="h-4 w-4" />
          Abuse Flags
        </button>
      </div>

      {activeTab === "queue" && (
        <VerificationQueue
          onSelectAgent={(id) => {
            setSelectedAgentId(id);
            setActiveTab("audit");
          }}
        />
      )}

      {activeTab === "audit" && (
        selectedAgentId ? (
          <AuditLogViewer agentId={selectedAgentId} />
        ) : (
          <p className="text-white/40 text-center py-8">
            Select an agent from the verification queue to view their audit trail.
          </p>
        )
      )}

      {activeTab === "abuse" && <AbuseFlagList />}
    </div>
  );
}
